import { Injectable, inject } from '@angular/core';

import { merge, Observable, Subject } from 'rxjs';

import { ConfigService } from '@fcom/core/services';
import { LanguageService } from '@fcom/ui-translate';

import { BreadcrumbItem } from '../../interfaces';
import { SchemaService } from '../schema/schema.service';

@Injectable()
export class BreadcrumbService {
  public breadcrumb$: Observable<BreadcrumbItem[]>;
  private breadcrumbItemsNormal$: Subject<BreadcrumbItem[]> = new Subject<BreadcrumbItem[]>(); // Populated from navigationPathList in CMS payload
  private breadcrumbItemsOverride$: Subject<BreadcrumbItem[]> = new Subject<BreadcrumbItem[]>(); // Populated by setBreadcrumb

  private readonly schemaService = inject(SchemaService);
  private readonly configService = inject(ConfigService);
  private readonly languageService = inject(LanguageService);

  private readonly homeLabel = this.languageService.translateSignal('actions.home');

  constructor() {
    this.constructBreadcrumbItemsNormal$();
    this.constructBreadcrumbItemsOverride$();
    this.constructBreadcrumbItems$();
  }

  public setBreadcrumbNormal(breadcrumbItems: BreadcrumbItem[]): void {
    this.breadcrumbItemsNormal$.next(breadcrumbItems);
    this.updateBreadcrumbSchema(breadcrumbItems);
  }

  public setBreadcrumb(breadcrumbItems: BreadcrumbItem[]): void {
    this.breadcrumbItemsOverride$.next(breadcrumbItems);
    this.updateBreadcrumbSchema(breadcrumbItems);
  }

  private updateBreadcrumbSchema(items: BreadcrumbItem[]): void {
    const baseUrl = this.configService.cfg.baseUrl;
    const languageRootUrl = `/${this.languageService.langValue}`;
    const homeItem: BreadcrumbItem = {
      title: this.homeLabel() ?? 'Home',
      url: languageRootUrl,
    };
    const schemaItems = items.filter(({ url }) => url !== languageRootUrl);

    this.schemaService.addBreadcrumbListSchema({ items: [homeItem, ...schemaItems], baseUrl });
  }

  private constructBreadcrumbItems$() {
    this.breadcrumb$ = merge(this.breadcrumbItemsNormal$, this.breadcrumbItemsOverride$);
  }

  private constructBreadcrumbItemsNormal$() {
    this.breadcrumbItemsNormal$ = new Subject<BreadcrumbItem[]>();
  }

  private constructBreadcrumbItemsOverride$() {
    this.breadcrumbItemsOverride$ = new Subject<BreadcrumbItem[]>();
  }
}
